<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "App",
  computed: {},
};
</script>

<style lang="less">
@import url("./base/commonCSS/common.less");
@import url("./assets/iconfont/iconfont.css");
#app {
  background: #fff;
  position: relative;
}
.van-swipe__indicators {
  bottom: 0 !important;
  i {
    width: 0.6rem !important;
    height: 0.06rem !important;
    background: #dadfe5 !important;
    border-radius: 0.04rem !important;
    &.van-swipe__indicator--active {
      background: @color !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue